
export default class DefaultFilterValues {

    public static getEmployerFilters() {
        return {
          lineOfBusiness: [],
          hq: [],
          industries: [],
          planTypes: [],
          entityTypes: [],
          participantRangeFilters: [0, 3000000],
          renewalDateFilters: [1, 12],
          carrierName: [],
          search: '',
        };
    }
      
    public static getBrokerFilters() {
        return {
          roles: [],
          jobTitles: [],
          case: [0,100],
          lineOfBusiness: [],
          employerHq: [],
          brokerOffices: [],
          planTypes: [],
          entityTypes: [],
          participantRanges: [0, 3000000],
          renewalDateFilters: [1, 12],
          industries: [],
          filterPrimaryBroker: false,
          carrierName: [],
          search: '',
        };
    }
      
    public static getProviderFilters() {
        return {
          states: [],
          search: '',
        };
    }

}